import React from "react";
import { RowTools } from "./SortableList";
import { DEFAULT_BANDS, bandIssues, newBand } from "../templateUtils";

const numValue = (v) => (v === "" ? "" : Number(v));

/** Overall score (0–100) → label, e.g. 90–100 Outstanding. Warns on overlaps. */
const RatingBandsEditor = ({ bands, onChange, readOnly }) => {
  const issues = bandIssues(bands);
  const setBand = (index, changes) =>
    onChange(bands.map((b, i) => (i === index ? { ...b, ...changes } : b)));

  return (
    <section className="builder-card" aria-labelledby="bands-title">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 id="bands-title" className="builder-card-title m-0">
          <i className="bi bi-bar-chart-steps"></i> Rating bands
        </h2>
        {!readOnly && bands.length === 0 && (
          <button
            type="button"
            className="btn btn-sm btn-link p-0"
            onClick={() => onChange(DEFAULT_BANDS.map((b) => newBand(b)))}
          >
            Use standard bands
          </button>
        )}
      </div>

      {issues.length > 0 && (
        <div className="alert alert-warning fs-080 py-2" role="alert">
          <i className="bi bi-exclamation-triangle me-1"></i>
          {issues.join(" ")}
        </div>
      )}

      <div className="band-grid band-grid--head" aria-hidden="true">
        <span>Min</span>
        <span>Max</span>
        <span>Label</span>
        <span></span>
      </div>
      {bands.map((b, index) => (
        <div key={b._id} className="band-grid">
          <input
            type="number"
            className="form-control form-control-sm"
            value={b.min}
            min="0"
            max="100"
            step="0.01"
            aria-label={`Band ${index + 1} minimum`}
            onChange={(e) => setBand(index, { min: numValue(e.target.value) })}
          />
          <input
            type="number"
            className="form-control form-control-sm"
            value={b.max}
            min="0"
            max="100"
            step="0.01"
            aria-label={`Band ${index + 1} maximum`}
            onChange={(e) => setBand(index, { max: numValue(e.target.value) })}
          />
          <input
            className="form-control form-control-sm"
            value={b.label}
            placeholder="e.g. Outstanding"
            aria-label={`Band ${index + 1} label`}
            onChange={(e) => setBand(index, { label: e.target.value })}
          />
          <RowTools
            moveUp={
              index > 0
                ? () =>
                    onChange(
                      bands.map((x, i) =>
                        i === index - 1
                          ? b
                          : i === index
                            ? bands[index - 1]
                            : x,
                      ),
                    )
                : null
            }
            moveDown={
              index < bands.length - 1
                ? () =>
                    onChange(
                      bands.map((x, i) =>
                        i === index + 1
                          ? b
                          : i === index
                            ? bands[index + 1]
                            : x,
                      ),
                    )
                : null
            }
            onRemove={() => onChange(bands.filter((_, i) => i !== index))}
            label={b.label || `band ${index + 1}`}
            readOnly={readOnly}
          />
        </div>
      ))}
      {!readOnly && (
        <button
          type="button"
          className="btn btn-sm btn-outline-primary mt-2"
          onClick={() => onChange([...bands, newBand()])}
        >
          <i className="bi bi-plus-lg"></i> Add band
        </button>
      )}
    </section>
  );
};

export default RatingBandsEditor;
